export enum PlatformType {
  NAVKA_ARENA = 'NAVKA_ARENA',
  NAVKA_SHOW = 'NAVKA_SHOW',
}
